import * as React from "react";
import DarkModeInverter from "nexia_mobile/components/DarkModeInverter";
import Environment from "nexia_mobile/environment";
import traneCommercialLogo from "nexia_mobile/styl/images/trane_commercial_logo.svg";
import amstdCommercialLogo from "nexia_mobile/styl/images/amstd_commercial_zoom_logo.svg";
import pivotLogo from "nexia_mobile/styl/images/pivot_logo.svg";
import Theme from "nx-components/Theme";
import prefixStyles from "nx-components/utils/prefixStyles";

const isTrane = Environment.isTraneCommercial();
const styles = prefixStyles({
  backgroundStyle: {
    display: "inline-block",
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat",
  },
  commercialDiv: {
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
  },
  commercialSpanHorizontal: {
    marginRight: "0.5em",
  },
});

const PivotMainMenuBrandLogo = () => {
  return (
    <DarkModeInverter>
      {({ maybeInvert }) => {
        return (
          <div
            data-component-name="PivotMainMenuBrandLogo"
            style={{ ...maybeInvert, ...styles.commercialDiv }}
          >
            <div
              style={{
                display: "flex",
                backgroundColor: "#60ae33",
                width: "100%",
                height: "3.2em",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                style={{
                  ...styles.backgroundStyle,
                  backgroundImage: `url(${
                    isTrane ? traneCommercialLogo : amstdCommercialLogo
                  })`,
                  width: isTrane ? "6em" : "12em",
                  height: "100%",
                  backgroundPositionY: "center",
                }}
              />
            </div>
            <div
              style={{
                ...Theme.Styles.flexLayout,
                backgroundColor: "#34505f",
                width: "100%",
                height: "3em",
                justifyContent: "center",
              }}
            >
              <span
                style={{
                  ...styles.commercialSpanHorizontal,
                  color: "white",
                }}
              >
                PIVOT
              </span>
              <span
                style={{
                  ...styles.backgroundStyle,
                  backgroundImage: `url(${pivotLogo})`,
                  width: "2em",
                  height: "2em",
                }}
              />
            </div>
          </div>
        );
      }}
    </DarkModeInverter>
  );
};

export default PivotMainMenuBrandLogo;



// WEBPACK FOOTER //
// ./src/components/BrandLogo/PivotMainMenuBrandLogo.jsx